export enum LocalStorageKeyName {
    Language = 'unvox:lang-code',
    Theme = 'unvox:theme',
    PreviewUrl = 'unvox:previewUrl',
}

export function SetLocalStorage(key: LocalStorageKeyName, value: string) {
    localStorage.setItem(key, value);
}

export function GetLocalStorage(key: LocalStorageKeyName) {
    return localStorage.getItem(key);
}

export function previewUrlStorageKey(jobId: string) {
    return `${LocalStorageKeyName.PreviewUrl}:${jobId}`;
}
